<template>
  <div class="analytic-customers-page scrollable">
    <div class="card-base card-shadow p-30">
      <el-tabs v-model="activeTab">
        <el-tab-pane v-for="tab in tabs" :label="tab" :name="tab.toLowerCase()">
          <CustomersChartsTabPane :chart-type="tab" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import CustomersChartsTabPane from './CustomersChartsTabPane'

  export default {
    name: 'CustomersPage',
    components: {
      CustomersChartsTabPane
    },
    data() {
      return {
        activeTab: 'customers',
        tabs: ['Customers', 'Plan', 'Reports']
      }
    }
  }
</script>
